// extracted by mini-css-extract-plugin
export default {"badge":"Card_badge__qp1hz","badgeContent":"Card_badgeContent__c9E0q","imageWrapper":"Card_imageWrapper__DsfZd","image":"Card_image__SoxjR"};